import { Component, Input, OnInit } from '@angular/core';
import { saveAs } from 'file-saver/FileSaver';
import { Observable } from 'rxjs';
import { DocumentSaveModel } from '../../../../models/documentSave.model';
import { DocumentationService } from '../../../../services/documentation/documentation.service';

@Component({
  selector: 'app-rejected-mortgage',
  templateUrl: './rejected-mortgage.component.html',
  styleUrls: ['./rejected-mortgage.component.scss'],
  standalone: false,
})
export class RejectedMortgageComponent implements OnInit {
  @Input() listRejectReasons: Array<string>;

  public listDocuments$: Observable<DocumentSaveModel[]>;
  private categoryRejected = 'MTG_C01';
  private typeRejected = 'DOC_38';

  constructor(private documentService: DocumentationService) {}

  ngOnInit() {
    this.getDocuments();
  }

  getDocuments() {
    this.listDocuments$ = this.documentService.getDocumentationSave(
      this.categoryRejected,
      this.typeRejected,
    );
  }

  downloadFile(document: DocumentSaveModel) {
    document['downloading'] = true;
    this.documentService.downloadFile(document.fileId).subscribe(
      (data) => {
        saveAs(data, document.name);
        document['downloading'] = false;
      },
      (err) => {
        document['downloading'] = false;
      },
    );
  }
}
